import { render, staticRenderFns } from "./SearchFilterToolbarFiltersBtn.vue?vue&type=template&id=74560c4d&scoped=true"
import script from "./SearchFilterToolbarFiltersBtn.vue?vue&type=script&lang=js"
export * from "./SearchFilterToolbarFiltersBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74560c4d",
  null
  
)

export default component.exports